import JustValidate, { Rules } from 'just-validate';
// import JustValidate from 'just-validate/dist/just-validate.es.js';

// import JustValidate from 'just-validate/dist/just-validate.es.js';
import { layer } from '../plugins/layer';
import axios from 'axios';

import { checkViewTransition } from '../utils/feature';


const initForms = (lang: Record<string, string>) => {

    function t(key: string, params: Record<string, string | number> = {}) {

        let text = lang[key];

        Object.keys(params).forEach(param => {
            text = text.replace(`{${param}}`, String(params[param]));
        });

        return text;
    }


    const contactForm = <HTMLFormElement>document.getElementById('contactForm');
    if (contactForm) {

        const btnShowForm = document.querySelector('.js-show-pform');
        const btnCloseForm = document.querySelector('.js-close-pfrom');
        const pFormBox = document.querySelector('.layer-pord-form');
        btnShowForm?.addEventListener('click', () => {
            checkViewTransition(() => {
                pFormBox?.classList.remove('hidden');
            });
        });
        btnCloseForm?.addEventListener('click', () => {
            checkViewTransition(() => {
                pFormBox?.classList.add('hidden');
            });
        });


        const validate = new JustValidate(contactForm);
        const postURL = contactForm.getAttribute('action');

        if (!postURL) return;

        validate
            .addField('.cform-name', [{ rule: Rules.Required, errorMessage: lang.required }])
            .addField('.cform-contact', [{ rule: Rules.Required, errorMessage: lang.required }])
            .addField('.cform-address', [{ rule: Rules.Required, errorMessage: lang.required }])
            .addField('.cform-location', [{ rule: Rules.Required, errorMessage: lang.required }])
            .addField('.cform-elevator', [{ rule: Rules.Required, errorMessage: lang.required }])
            // .addField('.cform-lastname', [{ rule: Rules.Required, errorMessage: lang.required }])
            // .addField('.cform-phone', [{ rule: Rules.MinLength, value: 11, errorMessage: t('min', { min: 11 }) }])
            .onSuccess((event: Event) => {
                const formData = new FormData(contactForm);
                const serializedData = new URLSearchParams(formData as any).toString();
                axios
                    .post(postURL, serializedData, {
                        headers: {
                            // 'X-WP-Nonce': WP_NONCE,
                        },
                    })
                    .then(function (res) {
                        // console.log(res);
                        if (res.status === 200) {
                            layer.msg(res.data.msg);
                            setTimeout(() => {
                                contactForm.reset();
                            }, 2000);
                        } else {
                            layer.msg(res.data.msg);
                        }
                    })
                    .catch(function (err) {
                        console.log(err);
                    });
            })
    }
}

export { initForms }
